/**
 * ShipmentInsightsTab - Aba Indicadores do modal da Remessa: só a linha do tempo (Gantt).
 * Reaproveita o Gantt da O.S. com grupos próprios da remessa.
 *
 * RELEASE: 2026-10-18 v1.0.0 - Versão inicial.
 */
import { useMemo } from 'react';
import { DetailsContentCard } from '@/components/shared/details-modal/DetailsModalPrimitives';
import { ServiceOrderStatusGantt, type GanttGroupConfig } from '@/components/service-orders/details/ServiceOrderStatusGantt';
import {
  SHIPMENT_GROUP_COLOR, SHIPMENT_GROUP_LABEL, SHIPMENT_GROUP_ORDER, shipmentStatusGroup, shipmentStatusSegments, type ShipmentStatusEvent,
} from '@/lib/logistics/shipmentInsights';
import { SHIPMENT_STATUS_META, type ShipmentStatus } from './shipmentStatus';

const CONFIG: GanttGroupConfig = {
  order: SHIPMENT_GROUP_ORDER, label: SHIPMENT_GROUP_LABEL, color: SHIPMENT_GROUP_COLOR,
  groupOf: shipmentStatusGroup,
  statusLabel: (s) => SHIPMENT_STATUS_META[s as ShipmentStatus]?.label ?? s,
};

interface Props {
  createdAt: string;
  events: ShipmentStatusEvent[];
  expectedDeliveryDate: string | null;
  deliveredAt: string | null;
}

export function ShipmentInsightsTab({ createdAt, events, expectedDeliveryDate, deliveredAt }: Props) {
  const segments = useMemo(() => shipmentStatusSegments(createdAt, events), [createdAt, events]);
  const last = segments[segments.length - 1];
  const end = last ? (last.end ?? new Date().toISOString()) : new Date().toISOString();

  return (
    <DetailsContentCard title="Linha do tempo da remessa">
      {segments.length === 0 ? (
        <p className="py-6 text-center text-sm text-muted-foreground">Não registrado</p>
      ) : (
        <ServiceOrderStatusGantt segments={segments} start={createdAt} end={end} config={CONFIG}
          markers={[
            // Data prevista é só data: marca no fim do dia local
            { label: 'Previsão de entrega', at: expectedDeliveryDate ? new Date(`${expectedDeliveryDate.slice(0, 10)}T23:59:00`).toISOString() : null },
            { label: 'Entregue', at: deliveredAt },
          ]} />
      )}
    </DetailsContentCard>
  );
}
